export type AppRoute =
  | { page: 'list'; id: null; duplicateFromId: null }
  | { page: 'editor'; id: string | null; duplicateFromId: string | null }
  | { page: 'abilities'; id: null; duplicateFromId: null }
  | { page: 'ability-editor'; id: string | null; duplicateFromId: null }
  | { page: 'kits'; id: null; duplicateFromId: null }
  | { page: 'kit-editor'; id: string | null; duplicateFromId: null }
  | { page: 'presets'; id: null; duplicateFromId: null }
  | { page: 'logs'; id: null; duplicateFromId: null };

export function readRoute(pathname: string): AppRoute {
  if (pathname === '/gameplay-presets') return { page: 'presets', id: null, duplicateFromId: null };
  if (pathname === '/abilities') return { page: 'abilities', id: null, duplicateFromId: null };
  if (pathname === '/abilities/new') return { page: 'ability-editor', id: null, duplicateFromId: null };
  const abilityMatch = pathname.match(/^\/abilities\/([^/]+)$/);
  if (abilityMatch) return { page: 'ability-editor', id: decodeURIComponent(abilityMatch[1]), duplicateFromId: null };
  if (pathname === '/kits') return { page: 'kits', id: null, duplicateFromId: null };
  if (pathname === '/kits/new') return { page: 'kit-editor', id: null, duplicateFromId: null };
  const kitMatch = pathname.match(/^\/kits\/([^/]+)$/);
  if (kitMatch) return { page: 'kit-editor', id: decodeURIComponent(kitMatch[1]), duplicateFromId: null };
  if (pathname === '/logs') return { page: 'logs', id: null, duplicateFromId: null };
  if (pathname === '/items/new') return { page: 'editor', id: null, duplicateFromId: null };
  const duplicateMatch = pathname.match(/^\/items\/duplicate\/([^/]+)$/);
  if (duplicateMatch) return { page: 'editor', id: null, duplicateFromId: decodeURIComponent(duplicateMatch[1]) };
  const itemMatch = pathname.match(/^\/items\/([^/]+)$/);
  if (itemMatch) return { page: 'editor', id: decodeURIComponent(itemMatch[1]), duplicateFromId: null };
  return { page: 'list', id: null, duplicateFromId: null };
}
